import {Tooltip, TooltipProps} from '@mui/material'
import React from 'react'
import './CustomTooltip.scss'

export const CustomTooltip = ({className, ...props }: TooltipProps) => {
    return <Tooltip {...props} classes={{ popper: className }} />
}
